import { useFeaturedSquiggles } from './useFeaturedSquiggles'
import type { ConditionHook } from '../_utils/createConditionHook'
import type { TokenDetailsFragment } from '@/gql/generated/graphql'

// SQUIGGLES_PROJECT_ID constant
const SQUIGGLES_PROJECT_ID =
  process.env.NEXT_PUBLIC_CURRENT_ENV === 'prod'
    ? '0x059edd72cd353df5106d2b9cc5ab83a52287ac3a-0' // chromie squiggles project contract on mainnet
    : '0x12f976648178b0c37e7b7ab218059b12b29dc78d-0' // mock testnet project contract for testing hooks

// Registry of condition hooks and their parameter factories
const conditionRegistry = {
  'Splash Screen Squiggle (ROM)': {
    hook: useFeaturedSquiggles,
    getParams: (token: TokenDetailsFragment) => ({
      ownerAddress: token.owner_address,
      projectId: SQUIGGLES_PROJECT_ID
    })
  }
} as const

export type ConditionKey = keyof typeof conditionRegistry

export function getConditionQuery(conditionKey: string): ConditionHook<any> | undefined {
  const config = conditionRegistry[conditionKey as ConditionKey]
  return config?.hook
}

export function getConditionParams(conditionKey: string, token: TokenDetailsFragment): any {
  const config = conditionRegistry[conditionKey as ConditionKey]
  return config?.getParams(token)
}

export function hasConditionOverride(key: string): key is ConditionKey {
  return key in conditionRegistry
}
